import script from "./hasRight.vue?vue&type=script&setup=true&lang=js"
export * from "./hasRight.vue?vue&type=script&setup=true&lang=js"

import "./hasRight.vue?vue&type=style&index=0&id=fc001432&lang=scss"

const __exports__ = script;

export default __exports__